import { Component } from '@angular/core';
import { NavController, NavParams, NavOptions } from 'ionic-angular';

import { WelcomePage } from '../welcome/welcome';
import { LoginProvider } from '../../providers/login-provider';
import { SharedDataProvider } from '../../providers/shared-data-provider';

import { User } from '../../providers/dto/user';

/**
 * Generated class for the Login page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  loginData = { username: "", password: "" };
  loginFailed = false;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private loginService: LoginProvider, private shared: SharedDataProvider) {
  }

  loginSuccessful() {
    console.log('Login was successful. Now try to navigate to WelcomePage');
    let navOpt: NavOptions = {};
    navOpt.animate = true;
    navOpt.animation = 'wp-transition';
    navOpt.duration = 1000;
    navOpt.direction = 'fade';

    this.navCtrl.push(WelcomePage, {}, navOpt);
  }

  loginError() {
    this.loginFailed = true;
  }

  tryLogin() {
    console.log('tryLogin was called.');
    this.loginFailed = false;

    this.loginService.login(
      this.loginData.username,
      this.loginData.password).subscribe(
      token => {
        if (token.valid) {
          let loginData = this.shared.getLoginData();
          loginData.credentials.token = token.token;
          loginData.credentials.username = this.loginData.username;
          loginData.credentials.userId = token.userid;
          loginData.isLoggedIn = true;

          this.shared.setLoginData(loginData);

          // save login data for next use:
          window.localStorage.setItem('username',this.loginData.username);
          window.localStorage.setItem('password',this.loginData.password);

          console.log("Login was successful: " + token);
          this.loginService.loadMyDetails().subscribe(
            (user: User) => {
              this.shared.setLoginUser(user);
              this.loginSuccessful();
            }
          )
        } else {
          console.log("Login was not successful: " + token);
          this.loginError();
        }
      },
      err => {
        console.log("Login was not successful: " + err);
        this.loginError();
      }
      );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad Login');
    this.loginData.username = window.localStorage.getItem('username');
    this.loginData.password = window.localStorage.getItem('password');
  }
}




// WEBPACK FOOTER //
// ./src/pages/login/login.ts